import React from 'react';
import './Footer.scss';

export const Footer = () => {
  return (
    <div className='footer'>
      <div>PappzFlix</div>
      <div>@2023, PappzFlix, Inc.</div>
    </div>
  )
}
